import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";


/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default{

    props: ['show', 'scheduleObject'],

    data() {
        return {
            locale: LocService,
            title: '',
            subTitle: '',
            id: 0,
            selectedButton: 'PLUS',
            hasError: null,
            isLoading: false,
            moneyInEur: 0,
            moneyInRsd: 0,
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                //TODO 
                let schedule = this.scheduleObject.schedule;
                this.id = schedule.id;
            }
        },
        amount: function(val, oldVal) {
            this.hasError = '';
        },
    },


    methods: {
        close() {
            this.$topnavbar.$emit('closeEditSchedule')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successEditSchedule')
        },
        onTabClicked: onTabClicked,
        reset: reset,
        closeSchedule: closeSchedule,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--large'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important; overflow: auto; padding: 15px;';
            }
            return 'height: 600px !important; overflow: auto; padding: 15px;';
        },
        validateEurInput(event) {
            if (event.target.value < 0) {
                event.target.value = 0;
                this.moneyInEur = 0;
            }
        },
        validateRsdInput(event) {
            if (event.target.value < 0) {
                event.target.value = 0;
                this.moneyInRsd = 0;
            }
        }
    }
}

function onTabClicked(tab){
    this.selectedButton = tab;
}

function reset() {
   this.moneyInRsd = 0;
   this.moneyInEur = 0;
}

function closeSchedule(){
    let _self = this;
    
        let request = {
            id: _self.id,
            comment: '',
            moneyRsdIn: _self.selectedButton === 'PLUS' ? _self.moneyInRsd : _self.moneyInRsd * -1,
            moneyEurIn: _self.selectedButton === 'PLUS' ? _self.moneyInEur : _self.moneyInEur * -1,
        }
    
        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {
        });
    
        AdminApiService.editSchedule(request)
            .then((response) => {
                _self.reset()
                _self.successUpdate();
                swal(LocService.t("label_success"), LocService.t("label_success"), 'success')
            
            })
            .catch((error) => {
                _self.isLoading = false;
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
}





// WEBPACK FOOTER //
// ./src/modals/EditSchedule.js